<div class="tooltip-wrapper tooltip-right" [style.top.px]="top">
  <div class="tooltip-arrow-wrapper">
    <div class="tooltip-arrow"></div>
  </div>
  <div class="tooltip-text {{ singleClass }}">
    <ul class="tooltip-action-list" *ngIf="numberOfActionItems > 0">
      <li *ngFor="let item of actionItems">
        <a (click)="onClickAction($event, item.action)" class="tooltip-action-item" id="tooltip-action-{{ item.action }}">
          <svg-icon *ngIf="item.icon" icon="{{ item.icon }}"></svg-icon>
          <span translate="{{ item.text }}"></span>
        </a>
      </li>
    </ul>
  </div>
</div>
